// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
// import Es6Promise from 'es6-promise'
// import "babel-polyfill"
// Es6Promise.polyfill();


import indexPage from './components/Index.vue'
import artist1 from './components/Artist1.vue'
import artist2 from './components/Artist2.vue'
import artist3 from './components/Artist3.vue'
import artist4 from './components/Artist4.vue'
import artist5 from './components/Artist5.vue'
import artist6 from './components/Artist6.vue'
import artist7 from './components/Artist7.vue'
import artist8 from './components/Artist8.vue'
import artist9 from './components/Artist9.vue'

Vue.use(VueRouter)
// Vue.config.productionTip = false
const router = new VueRouter({
    // mode: 'history',
    routes: [
        { path: '/', component: indexPage },
        { path: '/artist1', component: artist1 },
        { path: '/artist2', component: artist2 },
        { path: '/artist3', component: artist3 },
        { path: '/artist4', component: artist4 },
        { path: '/artist5', component: artist5 },
        { path: '/artist6', component: artist6 },
        { path: '/artist7', component: artist7 },
        { path: '/artist8', component: artist8 },
        { path: '/artist9', component: artist9 }
    ]
})

var kv = new Vue({
    // router,
    router: router,
    el: '#app',
    render: function (h) {
    return h(App)
  }
})
// kv.$mount('#App');



// WEBPACK FOOTER //
// ./src/main.js